// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1bkGU","footer":"ChangeClinic_footer__1_z2Z"};